import React from 'react';
import PageWrapper from 'src/components/PageWrapper';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';
import PartnerClients from './PartnerClients';
import PartnerDeployedClients from './PartnerDeployedClients';

const DeploymentCenter = () => {
  const match = useRouteMatch();

  return (
    <PageWrapper
      title="Deployment Center"
      padding={0}
      tabs={[
        { id: 1, path: `${match.url}/clients`, name: 'Queue' },
        { id: 2, path: `${match.url}/deployed`, name: 'Deployed' }
      ]}
    >
      <Switch>
        <Route path={`${match.path}/clients`} component={PartnerClients} />
        <Route path={`${match.path}/deployed`} component={PartnerDeployedClients} />
        <Redirect from={match.path} to={`${match.path}/clients`} />
      </Switch>
    </PageWrapper>
  );
};

DeploymentCenter.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
    path: PropTypes.string
  }).isRequired
};

export default DeploymentCenter;
